import React, { useState, useEffect } from 'react';
import apiService from '../../services/apiService';
import { PageLoader } from '../../components/PageLoader';

const AdminView = () => {
    const [accounts, setAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        apiService.fetchAllAccounts()
            .then(setAccounts)
            .catch(console.error)
            .finally(() => setIsLoading(false));
    }, []);

    const handleStatusChange = async (accountId, newStatus) => {
        try {
            await apiService.updateAccountStatus(accountId, newStatus);
            const updatedAccounts = await apiService.fetchAllAccounts();
            setAccounts(updatedAccounts);
        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    };

    if (isLoading) return <PageLoader text="Loading accounts..." />;

    return (
        <main className="p-8">
            <h1 className="text-4xl font-bold text-white mb-8">Admin: Account Management</h1>
            <div className="bg-slate-800/50 rounded-lg border border-slate-700 overflow-x-auto">
                <table className="w-full text-left">
                    <thead className="text-xs text-slate-400 uppercase bg-slate-700/50">
                        <tr>
                            <th className="p-4">Account Name</th>
                            <th className="p-4">Account ID</th>
                            <th className="p-4">Owner</th>
                            <th className="p-4">Created</th>
                            <th className="p-4">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accounts.map(acc => (
                            <tr key={acc._id} className="border-b border-slate-700 hover:bg-slate-700/30">
                                <td className="p-4 font-medium text-white">{acc.name}</td>
                                <td className="p-4 text-slate-300 font-mono text-xs">{acc._id}</td>
                                <td className="p-4 text-slate-300">{acc.owner?.name} ({acc.owner?.email})</td>
                                <td className="p-4 text-slate-300">{new Date(acc.createdAt).toLocaleDateString()}</td>
                                <td className="p-4">
                                    <select 
                                        value={acc.status} 
                                        onChange={(e) => handleStatusChange(acc._id, e.target.value)}
                                        className="bg-slate-700 border-slate-600 rounded-md p-1"
                                    >
                                        <option value="active">Active</option>
                                        <option value="deactivated">Deactivated</option>
                                        <option value="suspended">Suspended</option>
                                        <option value="deleted">Deleted</option>
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </main>
    );
};
export default AdminView;